import React, { useEffect, useState } from "react"
import { isMobile } from "react-device-detect"
import { handleMopinion } from "../../helpers/mopinionHelpers"
import Items from "./allowed-items-list"
import PopularItems from "./allowed-items-popular"
import AllowedItemsSearchbar from "./allowed-items-searchbar"
import AllowedItemsPageDescription from "./allowed-items-page-description"

const AllowedItemsListPage = ({ mopinionId, mopinionScript, items, remainingItems, popularItems, textKeys, descriptionIcons }) => {
  const searchForHash = (hash, update = false) => {
    let numberOfItems = update ? itemsShown : isMobile ? textKeys?.numberOfItemsMobile : textKeys?.numberOfItems
    let shownItems = remainingItems?.slice(0, numberOfItems) || []
    if (hash) {
      const popularItemsIndex = findIndexWithProperty(popularItems, "anchorId", hash)
      if (popularItemsIndex < 0) {
        // look in remaining items if hash is not found in popular items
        const index = findIndexWithProperty(remainingItems, "anchorId", hash)
        if (index > -1 && index > numberOfItems) {
          numberOfItems = index + 5
          shownItems = remainingItems?.slice(0, numberOfItems) || []
        }
      }
    }
    return { hash: hash || "", itemsShown: numberOfItems, shownItems: shownItems, numberOfItems: numberOfItems }
  }

  const initialHash = decodeURIComponent(window.location.hash?.replace("#", ""))
  const searchResult = searchForHash(hash, false)

  const [query, setQuery] = useState("")
  //the physical number of items shown in the list.
  const [itemsShown, setItemsShown] = useState(searchResult.itemsShown)

  //the actual items objects in the list, which are shown.
  const [shownItems, setShownItems] = useState(searchResult.shownItems)

  const [initialAmount, setInitialAmount] = useState(searchResult.numberOfItems)
  const [activateAutoScroll, setActivateAutoScroll] = useState(false)
  const [hash, setHash] = useState(initialHash || "")

  useEffect(() => {
    document.addEventListener("click", (event) => {
      var target = event.target
      if (target.tagName.toLowerCase() === "a") {
        var href = target.getAttribute("href")
        var link = new URL(href, window.location.href)
        if (link.hash && link.pathname === window.location.pathname && link.origin === window.location.origin) {
          event.preventDefault()
          const hash = decodeURIComponent(link.hash.replace("#", ""))
          window.location.hash = hash
          const searchResult = searchForHash(hash, true)

          setHash(hash || "")
          setItemsShown(searchResult.itemsShown)
          setShownItems(searchResult.shownItems)
          setInitialAmount(searchResult.numberOfItems)
        }
      }
    })
    handleMopinion(mopinionId)
  }, [])

  const findIndexWithProperty = (array, propName, propValue) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i][propName] === propValue) {
        return i
      }
    }
    return -1
  }

  useEffect(() => {
    // reset to zero state
    if (query.length < 2) {
      const numberOfItems = isMobile ? textKeys?.numberOfItemsMobile : textKeys?.numberOfItems
      const shownItems = remainingItems.slice(0, numberOfItems)

      setShownItems(shownItems)
      setItemsShown(numberOfItems)
      setActivateAutoScroll(false)

      return
    }

    setShownItems(
      items.filter((item) => {
        let matches = []
        if (item.title) matches.push(isMatch(item.title, query))
        if (item.info) matches.push(isMatch(item.info, query))
        if (item.category) matches.push(isMatch(item.category, query))
        return matches.includes(true)
      }),
    )
    setItemsShown(shownItems.length)
  }, [query])

  const isMatch = (text, query) => {
    const decodedText = decodeAndRemoveHtml(text)
    let isMatch = false
    const splitQuery = query.split(" ").filter(Boolean)
    if (splitQuery.length > 1) {
      for (let part of splitQuery) {
        if (part.length < 2) continue
        isMatch = matchString(decodedText, part)
        if (isMatch) return isMatch
      }
    } else {
      isMatch = matchString(decodedText, query)
    }
    return isMatch
  }

  const matchString = (text, query) => {
    return text.toLowerCase().trim().indexOf(query.toLowerCase().trim()) > -1
  }

  const decodeAndRemoveHtml = (html) => {
    var txt = document.createElement("textarea")
    txt.innerHTML = html
    return txt.value.replace(/<\/?[^>]+(>|$)/g, "")
  }

  const handleMoreClick = (increase) => {
    const newAmount = itemsShown + increase
    setShownItems(items.slice(0, newAmount))
    setItemsShown(newAmount)
    setActivateAutoScroll(true)

    var elements = document.getElementsByClassName("next-items-wrapper")
    if (elements.length > 0) {
      const element = elements[0]
      element.classList.remove("open")
      element.classList.add("opening")
      setTimeout(function () {
        element.classList.remove("opening")
        element.classList.add("open")
      }, 500)
    }
  }

  const handleHideClick = () => {
    const numberOfItems = isMobile ? textKeys?.numberOfItemsMobile : textKeys?.numberOfItems

    setShownItems(items.slice(0, numberOfItems))
    setItemsShown(numberOfItems)

    setActivateAutoScroll(false)
    const searchField = document.getElementById("items-search-field")
    if (searchField) {
      scrollIntoView(searchField)
    }
  }

  const handleResetQuery = () => {
    setQuery("")
    setHash("")
    setItemsShown(initialAmount)
    history.replaceState(null, null, window.location.pathname + window.location.search)
  }

  const scrollIntoView = (element) => {
    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight + 20
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
    })
  }

  const searchBarActive = query.length > 1

  return (
    <div className={`allowed-items-list ${descriptionIcons && descriptionIcons.length > 0 ? "has-description-icons" : ""}`}>
      <AllowedItemsPageDescription descriptionIcons={descriptionIcons} disclaimerText={textKeys?.disclaimerText} />
      <div className="items-list-wrapper">
        <AllowedItemsSearchbar
          query={query}
          setQuery={setQuery}
          searchBarActive={searchBarActive}
          handleResetQuery={handleResetQuery}
          searchFieldLabel={textKeys?.searchFieldLabel || "Søg på genstande"}
          clearSearchFieldLabel={textKeys?.ariaLabelClearSearch || "Ryd søgefelt"}
        />
        {query.length < 2 && popularItems && popularItems.length > 0 ? (
          <PopularItems
            mostPopularHeadline={textKeys?.mostPopularHeadline}
            popularItems={popularItems}
            hash={hash}
            setHash={setHash}
            scrollIntoView={scrollIntoView}
            mopinionScript={textKeys.mopinionScript}
            checkinLabel={textKeys?.checkinLabel || "Indtjekket"}
            handLuggageLabel={textKeys?.handLuggageLabel || "Håndbagage"}
            ariaLabelAllowed={textKeys?.ariaLabelAllowed || "Tilladt i {type}"}
            ariaLabelSometimesAllowed={textKeys?.ariaLabelSometimesAllowed || "Tilladt i {type} under særlige forhold"}
            ariaLabelNotAllowed={textKeys?.ariaLabelNotAllowed || "Ikke tilladt i {type}"}
          />
        ) : (
          ""
        )}
        <div id="allowed-items" className="items-list-inner padding-bottom">
          <Items
            alphabeticalHeadline={textKeys?.alphabeticalHeadline}
            searchBarActive={searchBarActive}
            query={query}
            shownItems={shownItems}
            setHash={setHash}
            allItems={items}
            increaseAmount={isMobile ? textKeys?.numberOfItemsIncrementMobile : textKeys?.numberOfItemsIncrement}
            initialAmount={initialAmount}
            amountShown={itemsShown}
            checkinLabel={textKeys?.checkinLabel || "Indtjekket"}
            handLuggageLabel={textKeys?.handLuggageLabel || "Håndbagage"}
            scrollIntoView={scrollIntoView}
            hash={hash}
            activateAutoScroll={activateAutoScroll}
            mopinionScript={mopinionScript || null}
            isMobile={isMobile}
            numberOfItemsIncrementMobile={textKeys?.numberOfItemsIncrementMobile}
            numberOfItemsIncrement={textKeys?.numberOfItemsIncrement}
            numberOfItems={itemsShown}
            showLessItemsText={textKeys?.showLessItemsText || "Vis færre"}
            showMoreItemsText={textKeys?.showMoreItemsText || "Vis flere"}
            handleHideClick={handleHideClick}
            handleMoreClick={handleMoreClick}
            noResultsSubHeader={textKeys?.noResultsSubHeader}
            noResultsHeader={textKeys?.noResultsHeader}
            noResultsText={textKeys?.noResultsText}
            ariaLabelAllowed={textKeys?.ariaLabelAllowed || "Tilladt i {type}"}
            ariaLabelSometimesAllowed={textKeys?.ariaLabelSometimesAllowed || "Tilladt i {type} under særlige forhold"}
            ariaLabelNotAllowed={textKeys?.ariaLabelNotAllowed || "Ikke tilladt i {type}"}
          />
        </div>
      </div>
    </div>
  )
}

export default AllowedItemsListPage
